import React from 'react';
import { ChromePicker } from 'react-color';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

export default function ColorPickerTemp({ color, setColor }) {
  const handleColorChange = (newColor) => {
    setColor(newColor.hex);
  };

  return (
    <>
      <Typography variant="h6">ቀለም ይምረጡ</Typography>
      <ChromePicker color={color} onChange={handleColorChange} />
    </>
  );
}

ColorPickerTemp.propTypes = {
  color: PropTypes.string.isRequired,
  setColor: PropTypes.func.isRequired,
};
